import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {filter, tap, withLatestFrom} from 'rxjs/operators';
import {EVENT_BUS} from '../../../../../shared/domain/tokens/event-bus.token';
import {Booking} from "../../domain/models/booking.model";
import {GetActiveBookingUseCase} from "../use-cases/get-active-booking.use-case";
import {UpdateBookingUseCase} from '../use-cases/update-booking.use-case';
import {
  AccountEntriesAppliedEvent
} from "../../../../../shared/application/events/account/account-entries-applied.event";

@Injectable()
export class AccountEntriesAppliedSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EVENT_BUS);
  private readonly updateBookingUseCase = inject(UpdateBookingUseCase);
  private readonly getActiveBookingUseCase = inject(GetActiveBookingUseCase);

  constructor() {
    this.eventBus.ofType(AccountEntriesAppliedEvent).pipe(
      withLatestFrom(this.getActiveBookingUseCase.execute()),
      filter(([, activeBooking]) => !!activeBooking),
      tap(([event, activeBooking]) => {
        this.updateBookingUseCase.execute(activeBooking as Booking, event.account.entriesTotal);
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }
}
